import { render, staticRenderFns } from "./CourseIntroduct.vue?vue&type=template&id=bebd5010&scoped=true&"
import script from "./CourseIntroduct.vue?vue&type=script&lang=js&"
export * from "./CourseIntroduct.vue?vue&type=script&lang=js&"
import style0 from "./CourseIntroduct.vue?vue&type=style&index=0&id=bebd5010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebd5010",
  null
  
)

export default component.exports